// extracted by mini-css-extract-plugin
module.exports = {"button":"reward-link-button_button__1xZhq","button_wrapper":"reward-link-button_button_wrapper__1tWKM"};